// extracted by mini-css-extract-plugin
module.exports = {"slideDiv":"_2PImlYEOPeFyv_V0pZI6tG"};